import React from 'react';

class AccountStatistics extends React.Component {
    render() {
        const toggleStatus = this.props.toggleStatus;
        const accountStats = this.props.accountStats;
        const lastUpdated = this.props.lastUpdated;

        return(
            <div id="monitor-stats">
                <p id="stat-limit">Monitor Limit: <span className="stat">
                    {(!accountStats) ? ("Loading...") : (accountStats.monitor_limit)}
                </span></p>
                <p id="stat-count">
                    <button onClick={() => toggleStatus("all")} className="button active" id="tab-all">
                        Active Monitors: <span className="stat">
                            {(!accountStats) ? ("Loading...") : (accountStats.total_monitors)}
                        </span>
                    </button>
                </p>
                <p id="stat-2">
                    <button onClick={() => toggleStatus("2")} className="button" id="tab-2">
                        Monitors Up: <span className="stat">
                            {(!accountStats) ? ("Loading...") : (accountStats.up_monitors)}
                        </span>
                    </button>
                </p>
                <p id="stat-1">
                    <button onClick={() => toggleStatus("9")} className="button" id="tab-9">
                        Monitors Down: <span className="stat">
                            {(!accountStats) ? ("Loading...") : (accountStats.down_monitors)}
                        </span>
                    </button>
                </p>
                <p id="time-stamp">Last Updated: <span className="stat">{lastUpdated}</span></p>
            </div>
        )
    }
}

export default AccountStatistics


// WEBPACK FOOTER //
// ./src/component_uptime/components/MonitorStats.js